<template>
  <div class="blogTableOfContents">
    <div class="blogTableOfContents__title">Spis treści</div>
    <ol class="blogTableOfContents__list">
      <li :key="index" class="blogTableOfContents__listItem" v-for="(item, index) in list">
        <a
          :href="`#${slugify(item, {
            lower: true,
            strict: true,
          })}`"
          class="blogTableOfContents__link"
          v-scroll-to
          v-html="item"
        />
      </li>
    </ol>
  </div>
</template>

<script>
import slugify from 'slugify';

export default {
  name: 'BlogTableOfContents',
  methods: { slugify },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.blogTableOfContents {
  background-color: $cBg;
  padding: 4rem;

  @include rwd('small-tablet') {
    padding: 3rem 2rem;
  }

  &__title {
    margin-bottom: 3rem;
    font-size: 2.2rem;
    line-height: 2.8rem;
    color: $cMain;
    font-weight: 600;
  }

  &__listItem {
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: $cMain;
    font-weight: 600;
    list-style: decimal;
    list-style-position: inside;
    margin-bottom: 1.7rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__link {
    color: $cSec;
    text-decoration: underline;
    transition: color $tr;

    &:hover {
      color: $cMain;
    }
  }
}
</style>
